import React, { useState, useEffect, useReducer } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  addFileGasProject,
  addFileGasProjectSingle,
  stopGasProject,
  deselectGp,
  getGasProjectFiles,
  getGasProjectsFullFilter,
  getGppByGpId,
  getListEngineer,
  getPackageInstaller,
  resetGasProjectFlag,
  resetPackage,
  selectGp,
  submitGasProjectAdmin,
  updateGasProject,
  updateGasProjectDetailsNew,
  deleteGasProjectFile,
  sendGasProjectToGas,
  getGasProjectsFullFilterExcel,
} from "store/actions"
import { getCurrentUser } from "helpers/service_helper"
import "./gasProjectProcess.scss"

import {
  Table,
  Pagination,
  Input,
  Space,
  Button,
  Row,
  Col,
  Checkbox,
  Radio,
  Card,
  Tag,
  Divider,
  Typography,
  Flex,
  Tooltip,
  Badge,
} from "antd"
import {
  SearchOutlined,
  FilterOutlined,
  ReloadOutlined,
  ClearOutlined,
  CalendarOutlined,
  EnvironmentOutlined,
  FileTextOutlined,
  UserOutlined,
  HomeOutlined,
  NumberOutlined,
} from "@ant-design/icons"
import { projectColumnsAnt } from "./ProjectColumnsAnt"
import ProjectSupportDrawer from "./ProjectSupportDrawer"
import AuditLogDrawer from "./AuditLogDrawer"
import PersianDatePicker from "./PersianDatePicker"
import { NumericInput } from "components/Common/NumericInput"
import Locations from "components/Common/Locations"

const { Search } = Input
const { Text, Title } = Typography

const ListGasProject = props => {
  const {
    lstGasProjectsFullFilter,
    lstGasProjectsFullFilterTotal,
    matches_sm,
    loading,
    selectedProject,
    onGetGasProjectsFullFilter,
    onGetGasProjectsFullFilterExcel,
    onSelectGasProject,
    onDeselectGasProject,
    openNotification,
    reload,
    userInfo,
    triggerReload,
    onResetGasProjectFlag
  } = props

  const [errorMessage, setErrorMessage] = useState(null)
  const [pageSize, setPageSize] = useState(10)
  const [pageIndex, setPageIndex] = useState(1)
  const [dateCreated, setDateCreated] = useState("")
  const [dateSendToGas, setDateSendToGas] = useState("")
  const [filterCity, setFilterCity] = useState(false)
  const [isFirstRender, setIsFirstRender] = useState(true)
  const [showFilters, setShowFilters] = useState(false)
  const [supportDrawer, setSupportDrawer] = useState({ open: false, fileNumber: null })
  const [auditDrawer, setAuditDrawer] = useState({ open: false, fileNumber: null })

  const [dataAddress, setDataAddress] = useState({
    sectionId: 0,
    fullAddress: {
      pro: "",
      cit: "",
      sec: "",
      lat: 35.311308,
      lng: 46.991271,
      mainAddress: "",
    },
  })

  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      fileNumber: null,
      searchValue: "",
      projectLevelEnum: 0,
      isStop: false,
      firstPlanFilter: true,
      isoFilter: false,
      serialNumber: "",
      isOk: false,
      inGasCoLevel: false,
      gasCoLevelTypeEnum: 1,
    }
  )

  const handleInput = evt => {
    const name = evt.target.name
    let newValue = evt.target.value
    if (evt.target.type === "checkbox") newValue = evt.target.checked
    if (name === "projectLevelEnum") {
      formInput.firstPlanFilter = newValue === 0
      formInput.isoFilter = newValue === 6
      onDeselectGasProject()
    }
    setFormInput({ [name]: newValue })
  }

  useEffect(() => {
    if (isFirstRender) {
      setIsFirstRender(false)
    } else {
      handleSearchGasProject("search")
    }
  }, [
    isFirstRender,
    formInput.projectLevelEnum,
    formInput.isStop,
    formInput.firstPlanFilter,
    formInput.isoFilter,
    formInput.serialNumber,
    formInput.isOk,
    formInput.inGasCoLevel,
    formInput.gasCoLevelTypeEnum,
  ])

  useEffect(async () => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
      onResetGasProjectFlag()
  }, [errorMessage, props.success, props.error])

  useEffect(async () => {
    await handleSearchGasProject("pageIndex")
    console.log(getCurrentUser())
  }, [pageIndex, pageSize])

  useEffect(async () => {
    if (reload) {
      await handleSearchGasProject()
    }
  }, [reload])

  useEffect(async () => {
    if (triggerReload > 0) {
      await handleSearchGasProject()
    }
  }, [triggerReload])

  const expandTable = record => {
    return <p style={{ margin: 0 }}>{record.description}</p>
  }

  const handleSearchGasProject = async val => {
    if (val !== "pageIndex") onDeselectGasProject()
    setPageIndex(val === "search" ? 1 : pageIndex)
    setPageSize(val === "search" ? 10 : pageSize)
    let searchQuery = {
      ...formInput,
      page: val === "search" ? 1 : pageIndex,
      pageSize: val === "search" ? 10 : pageSize,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarRegisterDate: dateCreated?.persian ? dateCreated.persian : "",
      solarDateSendToGas: dateSendToGas?.persian ? dateSendToGas.persian : "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      cityId: filterCity ? +dataAddress?.cityId : 0,
      exeName: formInput?.exeName ? formInput.exeName : "",
      landLordName: formInput?.landLordName ? formInput.landLordName : "",
      isStop: formInput.isStop,
      firstPlanFilter: formInput.firstPlanFilter,
      isoFilter: formInput.isoFilter,
      isFilterSubmitByAdmin: !formInput.isOk,
      serialNumber: formInput.serialNumber,
      inGasCoLevel: formInput.inGasCoLevel,
      gasCoLevelTypeEnum: formInput.inGasCoLevel ? formInput.gasCoLevelTypeEnum : 1,
    }
    onGetGasProjectsFullFilter(searchQuery)
  }

  const convertToExcel = async val => {
    let searchQuery = {
      ...formInput,
      page: 1,
      pageSize: lstGasProjectsFullFilterTotal,
      fileNumber: formInput.fileNumber ? formInput.fileNumber : 0,
      solarRegisterDate: dateCreated?.persian ? dateCreated.persian : "",
      solarDateSendToGas: dateSendToGas?.persian ? dateSendToGas.persian : "",
      idSection: filterCity ? +dataAddress?.sectionId : 0,
      cityId: filterCity ? +dataAddress?.cityId : 0,
      exeName: formInput?.exeName ? formInput.exeName : "",
      landLordName: formInput?.landLordName ? formInput.landLordName : "",
      isStop: formInput.isStop,
      firstPlanFilter: formInput.firstPlanFilter,
      isoFilter: formInput.isoFilter,
      isFilterSubmitByAdmin: !formInput.isOk,
      serialNumber: formInput.serialNumber,
      inGasCoLevel: formInput.inGasCoLevel,
      gasCoLevelTypeEnum: formInput.inGasCoLevel ? formInput.gasCoLevelTypeEnum : 1,
    }
    onGetGasProjectsFullFilterExcel(searchQuery)
  }

  // Status button configurations
  const statusButtons = [
    { label: "همه", value: 100, color: "default" },
    { label: "تخصیص طراحی", value: 0, color: "processing" },
    { label: "انتظار تایید طراحی", value: 4, color: "warning" },
    { label: "تخصیص نقشه", value: 1, color: "cyan" },
    { label: "انتظار تایید نقشه", value: 5, color: "orange" },
    { label: "تخصیص نقص", value: 3, color: "error" },
    { label: "نقشه تاییدشده", value: 2, color: "success" },
  ]

  return (
    <div className="list-gas-project">
      {/* Status Tabs */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          marginBottom: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: "12px 16px" }}
      >
        <Flex wrap="wrap" gap={8}>
          {statusButtons.map(({ label, value, color }) => (
            <Tag.CheckableTag
              key={value}
              checked={formInput.projectLevelEnum === value}
              onChange={() =>
                handleInput({ target: { name: "projectLevelEnum", value } })
              }
              style={{
                padding: "6px 16px",
                borderRadius: 8,
                fontSize: 13,
                fontWeight: 500,
                cursor: "pointer",
                border:
                  formInput.projectLevelEnum === value
                    ? "none"
                    : "1px solid #d9d9d9",
                background:
                  formInput.projectLevelEnum === value
                    ? "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)"
                    : "#fff",
                color:
                  formInput.projectLevelEnum === value ? "#fff" : "#595959",
              }}
            >
              {label}
            </Tag.CheckableTag>
          ))}
        </Flex>
      </Card>

      {/* Filters Section */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          marginBottom: 16,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: 16 }}
      >
        {/* Quick Filters Row */}
        <Flex wrap="wrap" gap={16} align="center" style={{ marginBottom: 16 }}>
          <Checkbox
            name="isStop"
            onChange={handleInput}
            checked={formInput.isStop}
            style={{
              padding: "4px 12px",
              background: formInput.isStop ? "#fff2e8" : "transparent",
              borderRadius: 6,
            }}
          >
            <Space>
              <span style={{ color: formInput.isStop ? "#fa541c" : undefined }}>
                فیلتر استاپ
              </span>
            </Space>
          </Checkbox>

          {+formInput.projectLevelEnum === 2 && (
            <>
              <Checkbox
                name="isOk"
                onChange={handleInput}
                checked={formInput.isOk}
                style={{
                  padding: "4px 12px",
                  background: formInput.isOk ? "#f6ffed" : "transparent",
                  borderRadius: 6,
                }}
              >
                <span style={{ color: formInput.isOk ? "#52c41a" : undefined }}>
                  تایید واحدگاز/نشده/همه
                </span>
              </Checkbox>
              <Checkbox
                name="inGasCoLevel"
                onChange={handleInput}
                checked={formInput.inGasCoLevel}
                style={{
                  padding: "4px 12px",
                  background: formInput.inGasCoLevel ? "#f6ffed" : "transparent",
                  borderRadius: 6,
                }}
              >
                <span
                  style={{
                    color: formInput.inGasCoLevel ? "#52c41a" : undefined,
                  }}
                >
                  کارتابل شرکت گاز
                </span>
              </Checkbox>
              {formInput.inGasCoLevel && (
                <Radio.Group
                  value={formInput.gasCoLevelTypeEnum}
                  onChange={e => setFormInput({ gasCoLevelTypeEnum: e.target.value })}
                  style={{
                    padding: "4px 12px",
                    background: "#f6ffed",
                    borderRadius: 6,
                  }}
                >
                  <Radio value={1}>آماده ارسال</Radio>
                  <Radio value={2}>ارسال دستی</Radio>
                  <Radio value={3}>ارسال سیستمی</Radio>
                </Radio.Group>
              )}
            </>
          )}

          <Checkbox
            onChange={e => setFilterCity(e.target.checked)}
            checked={filterCity}
            style={{
              padding: "4px 12px",
              background: filterCity ? "#e6f7ff" : "transparent",
              borderRadius: 6,
            }}
          >
            <Space>
              <EnvironmentOutlined
                style={{ color: filterCity ? "#1890ff" : undefined }}
              />
              <span style={{ color: filterCity ? "#1890ff" : undefined }}>
                فیلتر شهر
              </span>
            </Space>
          </Checkbox>

          <Button
            type="text"
            icon={<FilterOutlined />}
            onClick={() => setShowFilters(!showFilters)}
            style={{
              color: showFilters ? "#1890ff" : "#8c8c8c",
            }}
          >
            {showFilters ? "بستن فیلترها" : "فیلترهای بیشتر"}
          </Button>
        </Flex>

        <Divider style={{ margin: "12px 0" }} />

        {/* Search Fields */}
        <Row gutter={[12, 12]} align="middle">
          <Col>
            <PersianDatePicker
              setDefault={false}
              placeholder="تاریخ ثبت"
              setPersianDate={setDateCreated}
            />
          </Col>
          <Col>
            <PersianDatePicker
              setDefault={false}
              placeholder="تاریخ ارسال"
              setPersianDate={setDateSendToGas}
            />
          </Col>

          {filterCity && (
            <Col>
              <Locations
                setDataAddress={setDataAddress}
                matches_sm={matches_sm}
                isAccessCity={true}
                inUseFilter={true}
              />
            </Col>
          )}

          <Col xs={24} sm={24} md={24} lg={4}>
            <NumericInput
              style={{ width: "100%", borderRadius: 8 }}
              value={formInput.fileNumber}
              name="fileNumber"
              onChange={handleInput}
              placeholder="شماره پرونده"
              prefix={<FileTextOutlined style={{ color: "#bfbfbf" }} />}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={4}>
            <Input
              name="exeName"
              onChange={handleInput}
              placeholder="نام مجری"
              allowClear
              style={{ borderRadius: 8 }}
              prefix={<UserOutlined style={{ color: "#bfbfbf" }} />}
            />
          </Col>

          <Col xs={24} sm={24} md={24} lg={4}>
            <Input
              name="landLordName"
              onChange={handleInput}
              placeholder="نام مالک"
              allowClear
              style={{ borderRadius: 8 }}
              prefix={<HomeOutlined style={{ color: "#bfbfbf" }} />}
            />
          </Col>

          {showFilters && (
            <>
              <Col xs={24} sm={24} md={24} lg={4}>
                <Input
                  name="address"
                  onChange={handleInput}
                  placeholder="آدرس"
                  allowClear
                  style={{ borderRadius: 8 }}
                  prefix={<EnvironmentOutlined style={{ color: "#bfbfbf" }} />}
                />
              </Col>

              <Col xs={24} sm={24} md={24} lg={4}>
                <Input
                  name="serialNumber"
                  onChange={handleInput}
                  placeholder="شماره سریال"
                  allowClear
                  style={{ borderRadius: 8 }}
                  prefix={<NumberOutlined style={{ color: "#bfbfbf" }} />}
                />
              </Col>
            </>
          )}

          <Col xs={24} sm={24} md={6} lg={4}>
            <Button
              type="primary"
              icon={<SearchOutlined />}
              onClick={() => handleSearchGasProject("search")}
              block
              style={{
                borderRadius: 8,
                height: 40,
                background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
                border: "none",
              }}
            >
              جستجو
            </Button>
          </Col>
          <Col>
            <Button type="primary" onClick={() => convertToExcel()}>
              خروجی اکسل
            </Button>
          </Col>
        </Row>
      </Card>

      {/* Table Section */}
      <Card
        size="small"
        style={{
          borderRadius: 12,
          boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
        }}
        bodyStyle={{ padding: 0 }}
      >
        {/* Table Header */}
        <div
          style={{
            padding: "12px 16px",
            borderBottom: "1px solid #f0f0f0",
            background: "#fafafa",
            borderRadius: "12px 12px 0 0",
          }}
        >
          <Flex justify="space-between" align="center">
            <Space>
              <Text strong>لیست پرونده‌ها</Text>
              <Badge
                count={lstGasProjectsFullFilterTotal || 0}
                style={{ backgroundColor: "#1890ff" }}
                overflowCount={9999}
              />
            </Space>
            <Button
              type="text"
              icon={<ReloadOutlined spin={loading} />}
              onClick={() => handleSearchGasProject()}
              disabled={loading}
            >
              بروزرسانی
            </Button>
          </Flex>
        </div>

        {/* Data Table */}
        <Table
          loading={loading}
          size="small"
          pagination={false}
          scroll={{ x: 700 }}
          sticky
          columns={projectColumnsAnt({
            props,
            setErrorMessage,
            currentUser: getCurrentUser(),
            matches_sm,
            pageIndex,
            pageSize,
            userInfo,
            projectLevelFilter: formInput.projectLevelEnum,
            onOpenSupport: fileNumber =>
              setSupportDrawer({ open: true, fileNumber }),
            onOpenAuditLog: fileNumber =>
              setAuditDrawer({ open: true, fileNumber }),
          })}
          rowSelection={{
            selectedRowKeys:
              selectedProject.findIndex(x => x.page === pageIndex) !== -1
                ? selectedProject.find(x => x.page === pageIndex).selectArr
                : [],
            onChange: newSelectProject => {
              onSelectGasProject(pageIndex, newSelectProject)
            },
            getCheckboxProps: record => ({
              disabled: record.isOldProcess || record.isCancel,
            }),
          }}

          rowClassName={(record, i) =>
            `${i % 2 ? "odd" : "even"} ${
              record.isCancel ? "row-cancelled" : ""
            }`
          }
          rowKey={record => record.id}
          dataSource={lstGasProjectsFullFilter}
          style={{ borderRadius: "0 0 12px 12px" }}
        />

        {/* Pagination */}
        <div
          style={{
            padding: "16px",
            borderTop: "1px solid #f0f0f0",
            background: "#fafafa",
            borderRadius: "0 0 12px 12px",
          }}
        >
          <Pagination
            current={pageIndex}
            total={lstGasProjectsFullFilterTotal}
            pageSize={pageSize}
            showTotal={(total, range) => (
              <Text type="secondary">
                نمایش {range[0]} تا {range[1]} از {total} پرونده
              </Text>
            )}
            onChange={(page, size) => {
              setPageIndex(page)
              setPageSize(size)
            }}
            showSizeChanger
            pageSizeOptions={["10", "20", "50", "100"]}
            style={{ textAlign: "center" }}
          />
        </div>
      </Card>
      <ProjectSupportDrawer
        open={supportDrawer.open}
        fileNumber={supportDrawer.fileNumber}
        onClose={() => setSupportDrawer({ open: false, fileNumber: null })}
      />
      <AuditLogDrawer
        open={auditDrawer.open}
        fileNumber={auditDrawer.fileNumber}
        onClose={() => setAuditDrawer({ open: false, fileNumber: null })}
      />
    </div>
  )
}

const mapStateToProps = ({
  GasProjects,
  USERs,
  GasProjectProcesses,
  Engineers,
}) => ({
  lstGasProjectsFullFilter: GasProjects.lstGasProjectsFullFilter,
  lstGasProjectsFullFilterTotal: GasProjects.lstGasProjectsFullFilterTotal,
  lstGasProjectFiles: GasProjects.lstGasProjectFiles,
  lstPackageInstaller: GasProjects.lstPackageInstaller,
  lstEngineer: Engineers.lstEngineer,
  currentIdGasProject: GasProjects.currentIdGasProject,
  loading: GasProjects.loading,
  error: GasProjects.error,
  success: GasProjects.success,
  userBalance: USERs.userBalance,
  userInfo: USERs.userInfo,
  selectedProject: GasProjectProcesses.selectedProject,
  triggerReload: GasProjects.triggerReload,
})

const mapDispatchToProps = dispatch => ({
  onGetGasProjectsFullFilter: searchValue =>
    dispatch(getGasProjectsFullFilter(searchValue)),
  onGetGasProjectsFullFilterExcel: searchValue =>
    dispatch(getGasProjectsFullFilterExcel(searchValue)),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
  onGetProjectFiles: gasProjectId => dispatch(getGasProjectFiles(gasProjectId)),
  onAddFileGasProject: attachData => dispatch(addFileGasProject(attachData)),
  onAddFileGasProjectSingle: attachData =>
    dispatch(addFileGasProjectSingle(attachData)),
  onGetPackageInstaller: company => dispatch(getPackageInstaller(company)),
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onSelectGasProject: (gpId, selectArr) => dispatch(selectGp(gpId, selectArr)),
  onDeselectGasProject: () => dispatch(deselectGp()),
  onSubmitGasProjectByAdmin: gasProjectId =>
    dispatch(submitGasProjectAdmin({ gasProjectId, forPrepare: false })),
  onPrepareForMapByAdmin: gasProjectId =>
    dispatch(submitGasProjectAdmin({ gasProjectId, forPrepare: true })),
  onResetPackage: gpId => dispatch(resetPackage(gpId)),
  onStopGasProject: data => dispatch(stopGasProject(data)),
  onUpdateGasProjectDetailsNew: process =>
    dispatch(updateGasProjectDetailsNew(process)),
  onUpdateGasProject: gasProject => dispatch(updateGasProject(gasProject)),
  onDeleteGasProjectFile: id => dispatch(deleteGasProjectFile(id)),
  onSendGasProjectToGas: fileNumber =>
    dispatch(sendGasProjectToGas(fileNumber)),
  showDelete: true,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ListGasProject))
